import buyingPrice from "./master/buyingPrice";
import purchaseDiscount from "./master/purchaseDiscount";
import skuView from "./master/skuView";
import operatingUnit from "./master/operatingUnit";
export default {
  namespaced: true,
  modules: {
    buyingPrice: buyingPrice,
    purchaseDiscount: purchaseDiscount,
    skuView: skuView,
    operatingUnit: operatingUnit,
  },
};
